// Libraries
var React = require("react");

// Components
var GenericRichText = require('../RichText/GenericRichText');
var GenericImage = require('../GenericImage/GenericImage');
var OneHotspurButton = require('../OneHotspurButton/OneHotspurButton');

// Style
require("./ImageCopy.scss"); 

class ImageCopyModule extends React.Component {
  render() {
    const additionalSectionClass = this.props.data.isOneHotspur ? ' c-section--one-hotspur' : this.props.data.isPremium ? ' c-section--premium' : '';
    const additionalImageCopyClass = this.props.data.isOneHotspur ? ' c-image-copy--one-hotspur' : this.props.data.isPremium ? ' c-image-copy--premium' : '';
    return (
        <div className={`c-section${additionalSectionClass}`} id={this.props.data.id}>
            <div className="c-section__inner">
                <div className={`c-image-copy${additionalImageCopyClass}`}>
                    <h2 className="c-image-copy__title">{this.props.data.title}</h2>
            
                    {this.props.data.blocks.map((item,index) => {    
                        return(
                          <div className={`c-image-copy__item c-image-copy__item--text-${item.textAlignment} c-image-copy__item--image-${item.imageAlignment}${item.colour && item.colour !== '' ? ` c-image-copy__item--colour-${item.colour}` : ``}`} key={index} id={item.id}>
                                <div className="c-image-copy__image-container">
                                    <GenericImage loading="lazy" image={item.image} class="c-image-copy__image" alt={item.imageAltText || item.image.altText} />
                                </div>
                                <div className="c-image-copy__copy">
                                    <div className="c-image-copy__copy-inner">
                                        <h3 className="c-image-copy__subtitle">{item.title}</h3>
                                        <GenericRichText content={item.richtext} isPremium={this.props.data.isPremium} />
                                        {item.graphic && item.graphic.url ?
                                            <img src={item.graphic.url} alt={item.graphic.altText} loading="lazy" className="c-image-copy__graphic" />
                                        : null}
                                        <div className="c-image-copy__footer">
                                            {(item.cta.url && item.cta.caption) &&
                                                <p className="c-image-copy__action">
                                                    {this.props.data.isOneHotspur &&
                                                        <OneHotspurButton size="small" text={item.cta.caption} href={item.cta.url} target={item.cta.newWindow ? "_blank" : ""} rel={item.cta.newWindow ? "noopener noreferrer" : undefined} />
                                                    }
                                                    {!this.props.data.isOneHotspur &&
                                                        <a href={item.cta.url} target={item.cta.newWindow ? "_blank" : "_self"} rel={item.cta.newWindow ? "noopener noreferrer" : undefined} className={`c-button ${this.props.data.isPremium ? "c-button--premium" : ""}`}>{item.cta.caption}</a>
                                                    }
                                                </p>
                                            }
                                            {(item.ctaSecondary && item.ctaSecondary.url && item.ctaSecondary.caption) &&
                                                <p className="c-image-copy__action">
                                                    {this.props.data.isOneHotspur &&
                                                        <OneHotspurButton size="small" reverse="true" text={item.ctaSecondary.caption} href={item.ctaSecondary.url} target={item.ctaSecondary.newWindow ? "_blank" : ""} />
                                                    }
                                                    {!this.props.data.isOneHotspur &&
                                                        <a href={item.ctaSecondary.url} target={item.ctaSecondary.newWindow ? "_blank" : "_self"} rel={item.ctaSecondary.newWindow ? "noopener noreferrer" : undefined} className={`c-button ${this.props.data.isPremium ? "c-button--premium" : ""}`}>{item.ctaSecondary.caption}</a>
                                                    }
                                                </p>
                                            }
                                            {item.links.map((link,index) => {    
                                                return (
                                                    <div className="c-image-copy__link-container" key={index}>
                                                        <a href={link.url} className="c-image-copy__link" target={link.newWindow ? "_blank" : "_self"} rel={link.newWindow ? "noopener noreferrer" : undefined}>{link.caption}</a>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                
                </div>
            </div>
        </div>
    );
  }
}

module.exports = ImageCopyModule;



// WEBPACK FOOTER //
// ./src/components/ImageCopy/ImageCopy.js